import { render } from "./CollapseContent.vue?vue&type=template&id=25b7c0a6"
import script from "./CollapseContent.vue?vue&type=script&lang=js"
export * from "./CollapseContent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__